import React, { useState, useEffect } from "react";
import apiFetch from "./utils/api";
import Typeahead from "./components/Typeahead";

function FormatDateTime({ dt }) {
  try {
    const d = new Date(dt);
    return (
      <p>
        {d.toLocaleDateString("en-GB")}
        <br />
        <b>
          {d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
        </b>
      </p>
    );
  } catch (e) {
    return dt;
  }
}

export default function JiraPage({ user }) {
  const [status, setStatus] = useState({ state: "success", error: null });
  const [issues, setIssues] = useState([]);
  const [projects, setProjects] = useState([]);
  const [activities, setActivities] = useState([]);
  const [selectedMap, setSelectedMap] = useState({}); // idx -> {project, activity, checked, hours}
  const [jiraToken, setJiraToken] = useState("");

  function storeToken() {
    (async () => {
      if (jiraToken === "") return;
      try {
        const result = await apiFetch("/api/jira/token", {
          method: "POST",
          body: {
            token: jiraToken,
          },
        });
        user.UserJiraToken = result.token;
        setJiraToken(user.UserJiraToken);
      } catch (e) {}
    })();
  }

  useEffect(() => {
    (async () => {
      try {
        const p = await apiFetch("/api/projects");
        setProjects(Array.isArray(p.projects) ? p.projects : p);
      } catch (e) {}
      try {
        const a = await apiFetch("/api/activities");
        setActivities(Array.isArray(a.activities) ? a.activities : a);
      } catch (e) {}
    })();
  }, []);

  const fetchWeek = async () => {
    try {
      setStatus({ state: "loading", error: null })

      const resp = await apiFetch(`/api/jira/issues/week`);
      if (resp && resp.access === 401) throw new Error("Auth failed. Please check Token expiry date")
      if (resp && resp.error) throw new Error(`API Error: ${resp.error}`)
      if (!resp || !resp.issues || resp.issues.length === 0) throw new Error("No Jira issues found for this week")
      setIssues((resp && resp.issues) || []);

      setStatus({ state: "success", error: null })
    } catch (error) {
      setStatus({ state: "error", error: error.message ?? "Unknown error" })
    }
  };

  useEffect(() => {
    (async () => await fetchWeek())();
  }, []);

  const toggleChecked = (idx) => {
    setSelectedMap((m) => ({
      ...m,
      [idx]: { ...(m[idx] || {}), checked: !(m[idx] || {}).checked },
    }));
  };
  const setProjectFor = (idx, project) =>
    setSelectedMap((m) => ({ ...m, [idx]: { ...(m[idx] || {}), project } }));
  const setActivityFor = (idx, activity) =>
    setSelectedMap((m) => ({ ...m, [idx]: { ...(m[idx] || {}), activity } }));
  const setHoursFor = (idx, hours) =>
    setSelectedMap((m) => ({ ...m, [idx]: { ...(m[idx] || {}), hours } }));
  const setSummaryFor = (idx, summary) =>
    setSelectedMap((m) => ({ ...m, [idx]: { ...(m[idx] || {}), summary } }));

  const saveSelected = async () => {
    const recs = [];
    for (let i = 0; i < issues.length; i++) {
      const s = selectedMap[i];
      if (!s || !s.checked) continue;
      if (!s.hours) s.hours = "1";
      const it = issues[i];
      recs.push({
        resource: user.user,
        date: (it.updated || "").slice(0, 10),
        hours: Number(s.hours || 0.25),
        project_code: s.project ? s.project.id : null,
        sub_code: s.activity ? s.activity.id : null,
        division: s.project ? s.project.division : null,
        notes: `${it.key} - ${typeof s.summary === "string" ? s.summary : it.summary}`,
      });
    }

    if (recs.length === 0) return;
    try {
      const resp = await apiFetch("/api/timesheets/me", {
        method: "POST",
        body: { records: recs },
      });
      const inserted = resp && resp.inserted ? resp.inserted : 0;
      setStatus({ state: "display", error: "Saved " + inserted + " records" });
      if (inserted > 0) {
        // remove the first N selected issues similar to OutlookPage behavior
        const remaining = [];
        const newSelected = {};
        let toRemove = inserted;
        for (let i = 0; i < issues.length; i++) {
          const s = selectedMap[i];
          if (s && s.checked && toRemove > 0) {
            toRemove -= 1;
            continue;
          }
          const newIdx = remaining.length;
          remaining.push(issues[i]);
          if (selectedMap[i])
            newSelected[newIdx] = { ...selectedMap[i], checked: false };
        }
        setIssues(remaining);
        setSelectedMap(newSelected);
      }
    } catch (e) {
      setStatus({ state: "error", error: "Save failed: " + (e.message || e)});
    }
  };

  return (
    <div style={{ padding: 12 }}>
      <h3>Jira</h3>
      {/* <p style={{ margin: "16px" }}>This feature is still not yet available.</p> */}
      <div style={{ marginBottom: 8 }}>
        <div
          style={{
            display: "flex",
            gap: 8,
            alignItems: "center",
            marginBottom: 8,
          }}
        >
          {/* <label
            style={{ display: "flex", flexDirection: "column", fontSize: 12 }}
          >
            Jira user (email)
            <input
              type="email"
              value={jiraEmail}
              onChange={(e) => setJiraEmail(e.target.value)}
              style={{ marginLeft: 0, marginTop: 4, padding: 6 }}
            />
          </label> */}
          <button onClick={fetchWeek} disabled={status.state === "loading"}>
            Refresh
          </button>
          <button onClick={saveSelected} style={{ marginLeft: 8 }}>
            Save selected to Timesheets
          </button>
          <input
            style={{ textAlign: "center", width: 125 }}
            title="Please paste your JIRA API token here."
            placeholder={
              user.UserJiraToken
                ? user.UserJiraToken
                : "Enter your Jira API token"
            }
            type="text"
            value={jiraToken}
            onChange={(e) => setJiraToken(e.target.value)}
            onBlur={storeToken}
          />
          {status.state !== "success" && (
            <label
              style={{
                marginLeft: 8,
                color: status.state === "display" ? "green" : "darkred",
              }}
            >
              {status.state === "loading" ? "Loading..." : status.error }
            </label>
          )}
        </div>
      </div>
      {/* {statusMsg && (
        <div style={{ marginBottom: 12, color: "#b91c1c", fontWeight: 600 }}>
          {statusMsg}
        </div>
      )} */}

      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={{ width: 30 }}></th>
            <th style={{ width: 50 }}>Key</th>
            <th>Summary</th>
            <th style={{ width: 100 }}>Created</th>
            <th style={{ width: 100 }}>Updated</th>
            <th>Time</th>
            <th>Project</th>
            <th>Activity</th>
          </tr>
        </thead>
        <tbody>
          {issues.map((it, idx) => (
            <tr key={it.id} style={{ borderTop: "1px solid #eee" }}>
              <td style={{ textAlign: "center" }}>
                <input
                  type="checkbox"
                  checked={(selectedMap[idx] || {}).checked || false}
                  onChange={() => toggleChecked(idx)}
                />
              </td>
              <td>{it.key}</td>
              <td style={{ minWidth: 200 }}>
                <input
                  type="text"
                  value={
                    typeof (selectedMap[idx] || {}).summary === "string"
                      ? (selectedMap[idx] || {}).summary
                      : it.summary || ""
                  }
                  onChange={(e) => setSummaryFor(idx, e.target.value)}
                  style={{ width: "100%", padding: 6, boxSizing: "border-box" }}
                />
              </td>
              <td style={{ textAlign: "center" }}>
                <FormatDateTime dt={it.created} />
              </td>
              <td style={{ textAlign: "center" }}>
                <FormatDateTime dt={it.updated} />
              </td>
              <td style={{ textAlign: "center" }}>
                <input
                  type="number"
                  step="0.25"
                  min="0"
                  max="24"
                  value={
                    selectedMap[idx] &&
                    typeof selectedMap[idx].hours !== "undefined"
                      ? selectedMap[idx].hours
                      : "1"
                  }
                  onChange={(e) =>
                    setHoursFor(idx, parseFloat(e.target.value) || 0)
                  }
                  style={{ width: 50 }}
                />
              </td>
              <td style={{ minWidth: 200 }}>
                <Typeahead
                  items={projects}
                  value={(selectedMap[idx] || {}).project}
                  onChange={(p) => setProjectFor(idx, p)}
                  getItemKey={(it) => it.code}
                  getItemLabel={(it) => `${it.code} — ${it.desc}`}
                />
              </td>
              <td style={{ minWidth: 200 }}>
                <Typeahead
                  items={activities}
                  value={(selectedMap[idx] || {}).activity}
                  onChange={(a) => setActivityFor(idx, a)}
                  getItemKey={(it) => it.code}
                  getItemLabel={(it) => `${it.code} — ${it.desc}`}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
